import { doGet, doPost, doPut } from 'hooks/requests';

export const useSkyboxService = () => {
    const addSkyboxToken = (data) => doPost('/skybox/add-token/', data, '', false);

    const getSkyboxToken = (companyId) => doGet(`/skybox/get-token/?company_id=${companyId}`);

    const updateSkyboxToken = (data) => doPut('/skybox/update-token/', data, '', false);

    const updateSkyboxInvoiceStatus = (data) => doPut('/skybox/update-invoices/', data, '', false);

    const syncSkyboxInvoices = (data) => doPost('/skybox/sync-invoices/', data, '', false);

    return {
        addSkyboxToken,
        getSkyboxToken,
        updateSkyboxToken,
        syncSkyboxInvoices,
        updateSkyboxInvoiceStatus,

    };
};
